module.exports = __webpack_public_path__ + "img/completeIninSettingCheck.acd7ed06.svg";